import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id A8F9F185-D2AE-4DEE-845C-3C74801E2CD0
 * name seat-individual-suite
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-individual-suite.svg
 * tags
 */
export const SeatIndividualSuiteIcon = createSvgIcon(<><path d="M7,13A3,3 0 0,0 10,10A3,3 0 0,0 7,7A3,3 0 0,0 4,10A3,3 0 0,0 7,13M19,7H11V14H3V7H1V17H23V11A4,4 0 0,0 19,7Z" /></>, 'SeatIndividualSuiteIcon');
export default SeatIndividualSuiteIcon